import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { existeFecha } from "../tools";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';

const mensajeCampo = "Campo requerido";
const mensajeEdad = "Para completar su registro debe ser mayor de edad.";
var rfcCorrecto = false;
const mapState = (state) => {
	return {
		initialValues: {
			apaterno: state.registroAF.apaterno,
			amaterno: state.registroAF.amaterno,
			nombres: state.registroAF.nombres,
			email: state.registroAF.email,
			fecha_nacimiento: state.registroAF.fechaNacimiento,
			fecha_nacimiento_date: state.registroAF.fechaNacimientoDate,
			genero: state.registroAF.genero,
			rfc: state.registroAF.rfc,
			poliza: state.registroAF.poliza,
			lada_movil: state.registroAF.ladaCelular,
			telefono_movil: state.registroAF.telCelular,
		},
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
		avisoPrivacidad: (showAviso) => {
			dispatch({ "type": "AVISO_PRIVACIDAD", "showAviso": showAviso });
		},
		registrarDatos(bAccept) {
			dispatch({ "type": "REGISTRO_FAMILIAR_CONTRATO_ME", "mediosElectronicos": bAccept });
		},
		registrarDatos2(bAccept) {
			dispatch({ "type": "REGISTRO_FAMILIAR_CONTRATO_DP", "datosPersonales": bAccept });
		},
	};
};

const telefono = tipo => (value, campos) => {
	let numero = (value != undefined) ? value.replace("+", "").replace(" ", "") : "";
	let prefijo = (/lada/g.test(tipo)) ? "+" : "";
	campos[tipo] = (numero == "" || isNaN(numero)) ? "" : prefijo + numero;
};

const validate = (campos) => {
	const errors = {};

	if (!campos.email) {
		errors.email = "Campo requerido.";
	} else {
		campos.email = campos.email.replace(" ", "");
		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(campos.email)) {
			errors.email = "Formato de correo inválido. Intenta nuevamente.";
		}
	}

	if (!campos.nombres) {
		errors.nombres = "Campo requerido.";
	}

	if (!campos.apaterno) {
		errors.apaterno = "Campo requerido.";
	}

	if (!campos.amaterno) {
		errors.amaterno = "Campo requerido.";
	}

	if (!campos.telefono_movil) {
		errors.lada_movil = "Campo requerido.";
	} else if (campos.telefono_movil && ((campos.telefono_movil.length)) < 10) {
		errors.lada_movil = "Tu número de teléfono con lada incluida debe ser de 10 dígitos.";
	}

	if (!campos.fecha_nacimiento || campos.fecha_nacimiento == " ") {
		errors.fecha_nacimiento = "Campo requerido.";
	}

	if (!campos.rfc) {
		errors.rfc = "Campo requerido.";
	} else if (/^[a-zA-Z]{3,4}(\d{6})((\D|\d){2,3})?$/.test(campos.rfc) == false) {
		errors.rfc = "Formato de RFC inválido.";
	} else if (campos.rfc.length < 10 || (campos.rfc.length > 10 && campos.rfc.length != 13)) {
		errors.rfc = "RFC inválido, ingrese 10 o 13 carácteres.";
	} else if (campos.rfc && campos.fecha_nacimiento) {
		const dia = campos.fecha_nacimiento.substr(8, 9);
		const mes = campos.fecha_nacimiento.substr(5, 2);
		const anio = campos.fecha_nacimiento.substr(0, 4);
		var fechaComparativa = anio.substr(2, 4) + mes + dia;
		if (campos.rfc.substr("4", "6") !== fechaComparativa) {
			errors.rfc = "El RFC no concuerda con la fecha de nacimiento.";
		}
	}

	if (!campos.dia || !campos.mes || !campos.anio) {
		errors.dia = "Campo requerido.";
	} else if (existeFecha(campos.dia, campos.mes, campos.anio) == false) {
		errors.dia = "La fecha introducida es inválida.";
	}

	return errors;
};

const onSubmitFail = (errors, dispatch) => {
	if (errors.amaterno === "Campo requerido." && errors.apaterno === "Campo requerido." &&
		errors.dia == "Campo requerido." && errors.fecha_nacimiento === "Campo requerido." &&
		errors.lada_movil === "Campo requerido." && errors.nombres === "Campo requerido." && errors.rfc === "Campo requerido.") {
		dispatch({ "type": "EVENT_ACCESOFAMILIAR_DATOS-SIG-VACIOS", "dispositivo": "web" });
	} else if (errors.amaterno !== "Campo requerido." && errors.apaterno !== "Campo requerido." &&
		errors.dia !== "Campo requerido." && errors.fecha_nacimiento !== "Campo requerido." &&
		errors.lada_movil !== "Campo requerido." && errors.nombres !== "Campo requerido." && errors.rfc !== "Campo requerido.") {
		dispatch({ "type": "EVENT_ACCESOFAMILIAR_DATOS-SIG-INCORRECTOS", "dispositivo": "web" });
	}
};

const campoSettings = {
	fontFamily: 'Open Sans',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}

const floatingLabelStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#0C2040',
}

const floatingLabelFocusStyleSettings = {
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.5px',
	color: '#FF6B0B',
}

const campo = ({ input, label, max, type, disabled, error }) => {
	return (
		<MuiThemeProvider>
			<TextField
				{...input}
				disabled={disabled}
				value={input.value}
				name={input.name}
				floatingLabelText={label}
				fullWidth={true}
				underlineStyle={{ borderColor: '#AAC3EE' }}
				underlineFocusStyle={{ borderColor: '#FF6B0B' }}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				onFocus={(event) => { input.onFocus(event); }}
				onBlur={(event) => { input.onBlur(event); }}
				onChange={(event) => { input.onChange(event); }}
				maxLength={max}
				errorText={error}
				onKeyPress={(event) => {
					if (event.key === 'Enter') {
						handleKeyPress(input);
					}
				}}
			/>
		</MuiThemeProvider>
	);
}

const style = {
	color: "red",
	border: "none",
	marginTop: "-10px",
	position: "absolute"
}
class Datos extends React.Component {
	state = {
		inputType3: "",
		contrato: "",
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
		message1: false,
		mensaje1: "",
		message2: false,
		mensaje2: "",
		message3: false,
		mensaje3: "",
		message4: false,
		mensaje4: "",
		message5: false,
		mensaje5: "",
		message6: false,
		mensaje6: "",
	}

	handleDateChangeEvent = (ev) => {
		this.props.change("fecha_nacimiento", ev.format());
		this.props.change("fecha_nacimiento_date", ev.date.getTime());
	}

	componentWillMount = () => {
		this.setState({ inputType: 'text' });
		var _this = this;
		$(function () {
			$("input.datepicker-input").datepicker({
				format: "dd   -   MM   -   yyyy",
				language: "es",
				startDate: "-120y",
				endDate: "-16y",
				autoclose: true,
				disableTouchKeyboard: true
			}).on("changeDate", _this.handleDateChangeEvent);
		});
	}
	componentDidMount = () => {
		localStorage.removeItem("aceptarAviso");
		localStorage.removeItem("mediosElectronicos");
		localStorage.removeItem("lada_movil");
		localStorage.removeItem("telefono_movil");
	}

	handleChange = () => {
		this.getFechaNacimiento();
		this.onBlurFechaNacimiento();
	}

	getFechaNacimiento = () => {
		const fechaNacimiento = document.getElementsByName("fecha_nacimiento")[0].value;
		const dia = fechaNacimiento.substr(8, 9);
		const mes = fechaNacimiento.substr(5, 2);
		const anio = fechaNacimiento.substr(0, 4);

		if (fechaNacimiento !== "") {
			const date = new Date(fechaNacimiento);
			this.props.change("fecha_nacimiento", moment(anio + "-" + mes + "-" + dia, "YYYY-MM-DD").format("DD - MMMM - YYYY"));
			this.props.change("fecha_nacimiento_date", date.getTime());
			return dia + "/" + mes + "/" + anio;
		} else {
			return '';
		}
	}

	onFocusFechaNacimiento = (event) => {
		var dia = "";
		var mes = "";
		var anio = "";
		this.setState({ inputType: "date" });

		dia = event.currentTarget.value.substr(8, 9);
		mes = event.currentTarget.value.substr(5, 2);
		anio = event.currentTarget.value.substr(0, 4);

		document.getElementsByName("fecha_nacimiento")[0].value = dia + "/" + mes + "/" + anio;
	}

	onBlurFechaNacimiento = () => {
		const fecha = document.getElementsByName("fecha_nacimiento")[0].value;
		if (fecha === "") {
			this.setState({ message4: true });
			this.setState({ mensaje4: mensajeCampo });
		} else {
			this.setState({ message4: false });
			this.setState({ mensaje4: "" });
		}

		this.setState({ inputType: 'text' });
		if (fecha.includes("-")) {
			this.setState({ inputType: 'date' });
		}
	}

	onBlurPaterno = () => {
		const paterno = document.getElementsByName("apaterno")[0].value;
		if (paterno === "") {
			this.setState({ message1: true });
			this.setState({ mensaje1: mensajeCampo });
		} else {
			this.setState({ message1: false });
			this.setState({ mensaje1: "" });
		}
	}

	onBlurMaterno = () => {
		const materno = document.getElementsByName("amaterno")[0].value;
		if (materno === "") {
			this.setState({ message2: true });
			this.setState({ mensaje2: mensajeCampo });
		} else {
			this.setState({ message2: false });
			this.setState({ mensaje2: "" });
		}
	}

	onBlurNombres = () => {
		const nombre = document.getElementsByName("nombres")[0].value;
		if (nombre === "") {
			this.setState({ message3: true });
			this.setState({ mensaje3: mensajeCampo });
		} else {
			this.setState({ message3: false });
			this.setState({ mensaje3: "" });
		}
	}

	onBlurTelefono = () => {
		const telefono = document.getElementsByName("telefono_movil")[0].value;
		if (telefono === "") {
			this.setState({ message6: true });
			this.setState({ mensaje6: mensajeCampo });
		} else {
			this.setState({ message6: false });
			this.setState({ mensaje6: "" });
		}
	}

	showModal = () => {
		$("#modal-terminos-condiciones").modal({ backdrop: "static", keyboard: false });
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	onBlurRFC() {
		const dia = document.getElementsByName("fecha_nacimiento")[0].value.substr(8, 9);
		const mes = document.getElementsByName("fecha_nacimiento")[0].value.substr(5, 2);
		const anio = document.getElementsByName("fecha_nacimiento")[0].value.substr(0, 4);
		const rfc = document.getElementsByName("rfc")[0].value;
		var fechaComparativa = anio.substr(2, 4) + mes + dia;

		if (rfc === "") {
			this.setState({ message5: true });
			this.setState({ mensaje5: mensajeCampo });
		} else {
			this.setState({ message5: false });
			this.setState({ mensaje5: "" });
		}

		if (rfc.substr("4", "6") !== fechaComparativa) {
			rfcCorrecto= false;
			this.muestraTooltip(true, 'error', "Validacion", "El RFC no concuerda con la fecha de nacimiento.");
		}
		else {
			rfcCorrecto= true;
			this.muestraTooltip(false, "", "", "");
		}
	}

	siguiente = () => {
		const rfc = document.getElementsByName("rfc")[0].value;
		const nombre = document.getElementsByName("nombres")[0].value;
		const paterno = document.getElementsByName("apaterno")[0].value;
		const materno = document.getElementsByName("amaterno")[0].value;
		const telefono = document.getElementsByName("telefono_movil")[0].value;
		const fecha = document.getElementsByName("fecha_nacimiento")[0].value;
		
		var AñofechaNacimiento = moment(fecha).format('YYYY');
		var AñofechaActual = moment().format('YYYY');
		var edadAños = (parseInt(AñofechaActual) - parseInt(AñofechaNacimiento));
		
		this.onBlurPaterno();
		this.onBlurMaterno();
		this.onBlurNombres();
		this.onBlurFechaNacimiento();
		this.onBlurRFC();		
		this.onBlurTelefono();
		console.log(rfcCorrecto);
		if (rfc !== "" && nombre !== "" && paterno !== "" &&
			materno !== "" && telefono !== "" && fecha !== "" && rfcCorrecto) {
				if(edadAños >=16) {
					this.props.handleSubmit(values => this.props.onSubmit({ ...values }))();
				}else {
					this.setState({message4: true});
					this.setState({mensaje4 : mensajeEdad});
				}
		} else {
			console.log('no pasa');
		}
	}

	render() {

		return (
			<div>
				<form>
					<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
						show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
					</ModalSintillo>

					<div>
						<div className="text-content mt-34">
							<div className="datos-wrap mt-10">
								<div className="row">
									<div className="col-md-6 col-sm-6 col-xs-12">
										<div className="row">
											<div className="col-xs-12">
												<div className="input-wrap">
													<Field
														name="apaterno" component={campo}
														type="text" label="Apellido Paterno"
														onChange={this.onBlurPaterno.bind(this)}
														onBlur={this.onBlurPaterno.bind(this)}
													/>
													{this.state.message1 && <span style={style} >{this.state.mensaje1}</span>}
												</div>
											</div>
											<div className="col-xs-12">
												<div className="input-wrap">
													<Field
														name="amaterno" component={campo}
														type="text" label="Apellido Materno"
														onBlur={this.onBlurMaterno.bind(this)}
														onChange={this.onBlurMaterno.bind(this)}
													/>
													{this.state.message2 && <span style={style} >{this.state.mensaje2}</span>}
												</div>
											</div>
											<div className="col-xs-12">
												<div className="input-wrap">
													<Field
														name="nombres" component={campo}
														type="text" label="Nombre(s)"
														onBlur={this.onBlurNombres.bind(this)}
														onChange={this.onBlurNombres.bind(this)}
													/>
													{this.state.message3 && <span style={style} >{this.state.mensaje3}</span>}
												</div>
											</div>
										</div>
									</div>

									<div className="col-md-6 col-sm-6 col-xs-12">
										<div className="row">
											<div className="col-xs-12">
												<div className="input-wrap">
													<Field
														name="email" component={campo} disabled={true}
														type="text" label="Correo electrónico"
													/>
												</div>
											</div>
											<div className="col-xs-12 gnp-fecha">
												<div className="input-wrap">
													<Field
														component={campo} type={this.state.inputType}
														name="fecha_nacimiento" label="Fecha de Nacimiento"
														onChange={this.handleChange.bind(this)} max="10"
														onBlur={this.onBlurFechaNacimiento.bind(this)}
														onFocus={this.onFocusFechaNacimiento.bind(this)}
													/>
													<span id="calendario-registro" className="material-icons outlined"
														style={{ marginRight: "3px", marginTop: "-31px", borderBottom: "none" }}
														onClick={this.onFocusFechaNacimiento.bind(this)}>
														calendar_today
													</span>
													{this.state.message4 && <span style={style} >{this.state.mensaje4}</span>}
												</div>
											</div>
											<div className="col-xs-12">
												<div className="input-wrap" style={{ marginTop: "-10px" }}>
													<Field
														name="rfc" component={campo}
														type="text" label="RFC (homoclave)"
													/>
													{this.state.message5 && <span style={style} >{this.state.mensaje5}</span>}
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-md-6 col-sm-6 col-xs-12">
										<div className="input-wrap input-error-doble" style={{ marginTop: "-25px" }}>
											<Field
												name="telefono_movil" max="10" component={campo}
												type="text" label="Teléfono celular"
												onBlur={this.onBlurTelefono.bind(this)}
												onChange={this.onBlurTelefono.bind(this)}
											/>
											{this.state.message6 && <span style={style} >{this.state.mensaje6}</span>}
										</div>
									</div>
								</div>

							</div>
						</div>

						<Field name="poliza" component="input" type="hidden" />
						<Field name="genero" component="input" type="hidden" />
						<Field name="fecha_nacimiento" component="input" type="hidden" />
						<Field name="fecha_nacimiento_date" component="input" type="hidden" />

						<div className='datos-wrap' style={{ marginTop: "-40px" }}>
							<div className="row btn-bottom">
								<div className="col-xs-12">
									<button type="button" id="btnAceptarAviso" className="orange-rectangle"
										onClick={this.siguiente}>Continuar</button>
								</div>
							</div>
						</div>

					</div>

				</form>

			</div>
		);
	}
}

Datos = reduxForm({ form: "registro-datos", onSubmitFail })(Datos);

export default connect(mapState, mapDispatch)(Datos);



// WEBPACK FOOTER //
// ./src/gnp-registro-familiar/datos.frm.js